// extracted by mini-css-extract-plugin
module.exports = {"icon":"FiatCurrencyIcon_icon__T6_GV"};